<div class="nominative-holder">
    <div class="nh-header">
        <i class="fa-light fa-id-card"></i>
        <h2 class="nh-title">Datos del titular</h2>
    </div>

    <p class="nh-intro">
        Este evento tiene <strong>entradas nominativas</strong>: se emitirá a tu nombre y en el acceso te pedirán el
        mismo documento de identidad.
    </p>

    <form [formGroup]="holderForm" (submit)="submit()">
        <div class="nh-field">
            <label class="nh-label" for="holder-name">Nombre y apellidos</label>
            <div class="nh-input" [class.nh-input-invalid]="name.invalid && (name.dirty || name.touched)">
                <i class="fa-regular fa-user"></i>
                <input id="holder-name" type="text" placeholder="Nombre y apellidos" formControlName="name"
                    autocomplete="name">
            </div>
            <p class="nh-error" *ngIf="name.invalid && (name.dirty || name.touched)">
                Indica tu nombre y apellidos completos.
            </p>
        </div>

        <div class="nh-field">
            <label class="nh-label" for="holder-nif">Documento identificativo</label>
            <div class="nh-input" [class.nh-input-invalid]="nif.invalid && (nif.dirty || nif.touched)">
                <i class="fa-regular fa-address-card"></i>
                <input id="holder-nif" type="text" placeholder="DNI, NIE o pasaporte" formControlName="nif">
            </div>
            <p class="nh-error" *ngIf="nif.invalid && (nif.dirty || nif.touched)">
                Indica el documento con el que accederás al evento.
            </p>
        </div>

        <p class="nh-hint">
            En la entrada se imprimirá tu nombre y solo los últimos dígitos del documento.
        </p>

        <div class="nh-alert" *ngIf="errorMessage">
            <i class="fa-light fa-circle-exclamation"></i>
            <span>{{ errorMessage }}</span>
        </div>

        <div class="nh-actions">
            <button type="button" class="nh-btn nh-btn-ghost" (click)="cancel()" [disabled]="saving">Cancelar</button>
            <button type="submit" class="nh-btn nh-btn-solid" [disabled]="holderForm.invalid || saving">
                {{ saving ? 'Guardando...' : 'Continuar' }}
            </button>
        </div>
    </form>
</div>
